module.exports = __webpack_public_path__ + "static/img/crone_brewess.69bd0f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/crone_brewess.png
// module id = nxoH
// module chunks = 0